var RotationModel = /** @class */ (function () {
    function RotationModel(rotationDirection, variableName, minAngle, maxAngle, isProportion, minProportionScale, maxProportionScale, isReverseProportion, variableGroupName, dataSourceCode, variableVersion) {
        this.rotationDirection = rotationDirection;
        this.variableName = variableName;
        this.minAngle = minAngle;
        this.maxAngle = maxAngle;
        this.isProportion = isProportion;
        this.minProportionScale = minProportionScale;
        this.maxProportionScale = maxProportionScale;
        this.isReverseProportion = isReverseProportion;
        this.variableGroupName = variableGroupName;
        this.dataSourceCode = dataSourceCode;
        this.variableVersion = variableVersion;
    }
    return RotationModel;
}());
export { RotationModel };
